import React, { useState, useEffect } from "react";
import { fontstyle1, fontstyle3 } from "../../utils/fonts";
import Signinimg from "../../assets/signin.png";
import Header from "../../layouts/Authscreens/Header";
import instance from "../../utils/axios";
import history from "../../utils/history";

const Signin = () => {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    instance
      .post("/auth/dsignin", {
        email: localStorage.getItem("dofeedbackin_email"),
        password: localStorage.getItem("dofeedbackin_token")
      })
      .then((res) => {
        if (res.data.status === "error") {
        } else {
          history.push("/home/" + localStorage.getItem("dofeedbackin_uid"));
          history.go();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const data = {
      email: e.target.email.value,
      password: e.target.password.value
    };
    instance
      .post("/auth/signin", data)
      .then((res) => {
        if (res.data.status === "error") {
          setLoading(false);
          setError(res.data.message);
        } else {
          setLoading(false);
          localStorage.setItem("dofeedbackin_uid", res.data.result[0]._id);
          localStorage.setItem("dofeedbackin_email", res.data.result[0].email);
          localStorage.setItem(
            "dofeedbackin_token",
            res.data.result[0].password
          );
          history.push("/home/" + res.data.result[0]._id);
          history.go();
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  return (
    <div
      className="w-full h-full"
      style={{
        backgroundImage: `url(${Signinimg})`,
        backgroundSize: "400px",
        backgroundPosition: "left",
        backgroundRepeat: "no-repeat"
      }}
    >
      <Header />
      <div
        className="w-full h-[70vh] flex flex-col  items-center justify-center bg-white sm:bg-transparent"
        style={fontstyle1}
      >
        <div className=" text-2xl mb-10 text-[#FF834F]">
          <p>Sign In for an Account</p>
        </div>
        {/* <div className="flex p-2 items-center border border-black rounded gap-2">
          <FaGoogle />
          Sign In with Google
        </div>
        <div className="text-sm text-gray-400 mb-10 mt-10">
          ------ Or with Email ------
        </div> */}
        <div>{error}</div>

        <form onSubmit={handleSubmit}>
          <input
            required
            id="email"
            name="email"
            type="email"
            className="focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-700 rounded border text-black"
            placeholder="Email Id"
            style={fontstyle3}
          />

          <input
            required
            id="password"
            name="password"
            type="password"
            className="focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-700 rounded border text-black mt-4"
            placeholder="Password"
            style={fontstyle3}
          />
          <div className="flex mt-4 items-center gap-4 flex-col sm:flex-row">
            <button
              type="submit"
              className="p-2 bg-[#FF834F] text-white rounded pl-5 pr-5 cursor-pointer flex items-center gap-3"
              style={fontstyle1}
            >
              {loading ? (
                <svg
                  class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    class="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                  ></circle>
                  <path
                    class="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
              ) : (
                ""
              )}
              Sign In
            </button>
            <div className="text-sm">
              Don't have an account?{" "}
              {/* <a href="/signup" className="font-bold">
                Sign Up
              </a> */}
              <a href="/signup" className="font-bold">
                Sign Up
              </a>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Signin;
